import React, { useState, useEffect } from "react";
import moment from "moment";
import ReactTable from "react-table";
import { RegistrarPP } from "./Form";
import { notificarMsg } from "../Almacenes/AlmacenNotify";
import matchSorter from "match-sorter";
import Modal from "./PedidoPModal";
import {
    BotonPDFpequeno,
    BotonTicket
} from '../Plantillas/Botones';
import ReportePedidoProduccion from './PdfPedidoP';
import { printTicketPedidoProduccion } from "./PrintTicket";
import { pdf } from '@react-pdf/renderer';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const CALENDAR_STYLE = {
  border: "0.5px solid #acacac",
  borderRadius: "25px",
  outline: "none",
  flexBasis: "50%",
  alignSelf: "center",
};

export default function PedidosProduccion() {
    const [desde, setDesde] = useState(moment().utc().format("YYYY-MM-DD"));
    const [hasta, setHasta] = useState(moment().utc().format("YYYY-MM-DD"));
    const [pedidos, setPedidos] = useState([]);
    const [currentPedidoId, setCurrentPedidoId] = useState(undefined);
    const [showRegistrarModal, setShowRegistrarModal] = useState(false);
    const [generandoPDF, setGenerandoPDF] = useState(false);
    
    const [user, setUser] = useState(undefined);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalInfo, setSucursalInfo] = useState({
        Nombre: "Sucursal del usuario en sesión"
    });
    const [currentSucursalId, setCurrentSucursalId] = useState(undefined);
    const [canChangeSucursal, setCanChangeSucursal] = useState(false);
    const [userLoaded, setUserLoaded] = useState(false);
    const [excelSheet, setExcelSheet] = useState([])

    const getPedidos = async () => {
        if (!userLoaded) return;
        
        try {
            const sucursalParam = currentSucursalId || user?.IdSucursal || "";
            const timestamp = new Date().getTime();
            const response = await fetch(
                `/api/pedidosProduccion?start=${desde}&end=${hasta}&sucursal=${sucursalParam}&_=${timestamp}`
            );
            const data = await response.json();
            setPedidos(data);
        } catch (error) {
            console.error("Error fetching pedidos:", error);
        }
    };

    const fetchUserData = async () => {
        try {
            const response = await fetch(`/api/configFactElectronica/User`);
            const data = await response.json();

            const {objuser: {sucursal, ...user}, extImg } = data;

            setUser({...user});
            setSucursalInfo(sucursal);
            setCurrentSucursalId(user.IdSucursal);
            setUserLoaded(true);
            fetchRoleValidation();
        } catch (e) {
            console.error(e);
            setUserLoaded(true);
        }
    }
 
    const fetchRoleValidation = async () => {
        try {
            const response = await fetch(`/api/configFactElectronica/ChangeSucursal`);
            setCanChangeSucursal(response.ok);
        } catch (e) {
            console.error(e);
        }
    }

    const fetchSucursales = async () => {
        try {
            const response = await fetch("/api/configFactElectronica/SucursalEmpresa");
            const sucursales = await response.json();
            setSucursales([...sucursales]);
        } catch (e) {
            console.error(e);
        }
    }

    const handleDownloadPDF = async (pedido) => {
        try {
            setGenerandoPDF(true);
            
            const timeoutPromise = new Promise((_, reject) => 
                setTimeout(() => reject(new Error('Timeout generando PDF')), 30000)
            );

            const fetchPromise = (async () => {
                const [responsePedido, responseDetalles] = await Promise.all([
                    fetch(`/api/pedidosProduccion/item/${pedido.IdPedidoProduccion}`),
                    fetch(`/api/pedidosProduccion/detallepe/${pedido.IdPedidoProduccion}`)
                ]);

                if (!responsePedido.ok || !responseDetalles.ok) {
                    throw new Error('Error al obtener datos del pedido');
                }

                const [pedidoData, detallesData] = await Promise.all([
                    responsePedido.json(),
                    responseDetalles.json()
                ]);
                
                await generarYDescargarPDF(pedidoData[0], detallesData, pedido.IdPedidoProduccion);
            })();

            await Promise.race([fetchPromise, timeoutPromise]);
            
        } catch (error) {
            console.error("Error al generar PDF:", error);
            const mensaje = error.message === 'Timeout generando PDF' 
                ? "Tiempo de espera agotado al generar el PDF" 
                : "Error al generar el PDF";
            notificarMsg(mensaje, "error");
        } finally {
            setGenerandoPDF(false);
        }
    }

    const generarYDescargarPDF = async (pedido, detalles, nroPedido) => {
        try {
            const blob = await pdf(
                <ReportePedidoProduccion 
                    pedido={pedido}
                    detalles={detalles}
                    extImg={user?.extImg || 'png'}
                />
            ).toBlob();
            
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Pedido_Produccion_${nroPedido}.pdf`;
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            window.URL.revokeObjectURL(url);
            
            notificarMsg("PDF descargado exitosamente", "success");
            
        } catch (error) {
            console.error("Error en la generación del PDF:", error);
            throw error;
        }
    }

    const handleDownloadTicketPedido = async (pedido) => {
        try {

            const responseCola = await fetch('/api/pedidosProduccion/colaticket', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ IdPedidoProduccion: pedido.IdPedidoProduccion })
            });

            const colaData = await responseCola.json();

            if (!responseCola.ok) {
                throw new Error(colaData.message || colaData.mensaje || 'Error al agregar a la cola de impresión');
            }else{
                alert("Pedido agregado a la cola de impresión correctamente");
            }

            const responsePedido = await fetch(`/api/pedidosProduccion/item/${pedido.IdPedidoProduccion}`);
            const pedidoData = await responsePedido.json();
            
            const responseDetalles = await fetch(`/api/pedidosProduccion/detallepe/${pedido.IdPedidoProduccion}`);
            const detallesData = await responseDetalles.json();
            
            await printTicketPedidoProduccion(
                detallesData, 
                pedidoData[0],
            );
        } catch (error) {
            console.error("Error al imprimir ticket:", error);
            notificarMsg("Error al imprimir ticket", "error");
        }
    } 

    useEffect(() => {
        fetchUserData();
        const url = new URL(window.location.href);
        const start = url.searchParams.get("start");
        const end = url.searchParams.get("end");

        if (start && end) {
            setDesde(start);
            setHasta(end);
        }
    }, [])

    useEffect(() => {
        if (canChangeSucursal) {
            fetchSucursales();
        }
    }, [canChangeSucursal]);

    useEffect(() => {
        if (userLoaded) {
            const url = new URL(window.location.href);
            url.searchParams.set("start", desde);
            url.searchParams.set("end", hasta);
            window.history.pushState({}, "", url);

            getPedidos();
        }
    }, [desde, hasta, currentSucursalId, userLoaded]);

    useEffect(() => {
        setExcelSheet([
            {
                columns: [
                    { title: "Usuario", width: { wch: 20} },
                    { title: "Sucursal", width: { wch: 20} },
                    { title: "Fecha de registro", width: { wch: 20} },
                    { title: "Fecha de entrega", width: { wch: 20} },   
                    { title: "Estado", width: { wch: 15} },
                    { title: "Observación", width: { wch: 30} },
                ],

                data: pedidos.map( p => {
                    return [
                        { value: p.NombreUsuario },
                        { value: p.NombreSucursal },
                        { value: moment(p.FechaEmision).format("DD/MM/YYYY") },
                        { value: moment(p.FechaEntrega).format("DD/MM/YYYY") },
                        { value: p.Estado },
                        { value: p.Observacion },
                    ];
                })
            }
        ])
    }, [pedidos]);

    const handlePedidoRegistered = (pedidoId) => {
        setCurrentPedidoId(pedidoId);
        setShowRegistrarModal(false);
        getPedidos();
        notificarMsg("Pedido registrado exitosamente", "success");
    };

    const handleCloseRegistrarModal = () => {
        setShowRegistrarModal(false);
        getPedidos();
    };

    return (
        <>
            <div className="ventas-fpay-section">
                <div className="abed__caja-fondo-blanco-m-2 mx-auto mt-3 col-12 col-md-8 col-lg-6">
                    <div className="justify-content-center d-flex">
                        <span className="align-self-center letra-fecha-fpay">Desde: </span>
                        <input
                            type="date"
                            onChange={(e) => setDesde(e.target.value)}
                            value={desde}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={CALENDAR_STYLE}
                        />
                        <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                        <input
                            type="date"
                            onChange={(e) => setHasta(e.target.value)}
                            value={hasta}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={CALENDAR_STYLE}
                        />
                    </div>
                </div>
                <div className="pt-3 container">
                    <div className={`col-12 no-pad ${canChangeSucursal ? '' : 'caja-fondo-blanco-m-2'}`}>
                        {canChangeSucursal ?
                            <div className="caja-fondo-blanco-m-2">
                                <label className="sucursal-text-color" htmlFor="sucursales">Seleccione una sucursal</label>
                                <select value={currentSucursalId} name="sucursales" id="sucursales"
                                        className="w-100 select-search-box__search"
                                        onChange={e => setCurrentSucursalId(e.target.value)}>
                                {sucursales.map((s, i) => <option key={i} value={s.IdSucursal}>{s.Nombre}</option>)}
                                </select>
                            </div> : <label className="sucursal-text-color container">{sucursalInfo.Nombre}</label>}
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="d-flex justify-content-end seccion-btn-generar">
                        <div className='ml-3'>
                            <div className='seccion-btn-verde-mfp'>
                                <span className='p-0'>
                                <ExcelFile
                                    element={
                                        <button className="btn btn-outline-primary btn-excel-mfp">
                                            <a className="">Descargar Excel</a>
                                        </button>
                                    }
                                    filename="pedidosProduccion"
                                >
                                    <ExcelSheet dataSet={excelSheet} name="pedidosProduccion"/>
                                </ExcelFile>
                                </span>
                            </div>
                        </div>
                        <button 
                            type="button" 
                            className="ml-3 btn btn-outline-primary btn-verde-mfp mb-2"
                            onClick={() => setShowRegistrarModal(true)}
                        >
                            Registrar Pedido
                        </button>
                    </div> 
                    
                    <div className="mt-3">
                        <ReactTable 
                            data={pedidos}
                            filterable
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: "Acciones",
                                            headerClassName: "",
                                            width: 280,
                                            Cell: (row) => {
                                                return (
                                                    <div>
                                                        <BotonPDFpequeno 
                                                            className="mr-2"
                                                            onClick={() => handleDownloadPDF(row.original)}
                                                            title="Descargar PDF"
                                                            disabled={generandoPDF}
                                                        />
                                                        {generandoPDF && (
                                                            <span className="ml-2 small text-muted">Generando PDF...</span>
                                                        )}
                                                        <BotonTicket
                                                            className="mr-2"
                                                            onClick={() => handleDownloadTicketPedido(row.original)}
                                                            title="Ticket"
                                                        />
                                                    </div>
                                                );
                                            }
                                        },
                                        {
                                            Header: "Usuario",
                                            id: "Usuario",
                                            headerClassName: "",
                                            width: 120,
                                            filterAll: true,
                                            accessor: (d) => d.NombreUsuario,
                                        },
                                        {
                                            Header: "Sucursal",
                                            id: "Sucursal",
                                            headerClassName: "",
                                            width: 120,
                                            filterAll: true,
                                            accessor: (d) => d.NombreSucursal,
                                        },
                                        {
                                            Header: "Fecha de registro",
                                            id: "FechaEmision",
                                            headerClassName: "",
                                            width: 150,
                                            filterAll: true,
                                            accessor: (d) => moment(d.FechaEmision).format("DD/MM/YYYY"),
                                        },
                                        {
                                            Header: "Fecha de entrega",
                                            id: "FechaEntrega",
                                            headerClassName: "",
                                            width: 150,
                                            filterAll: true,
                                            accessor: (d) => {
                                                const fecha = moment(d.FechaEntrega);
                                                let label = fecha.fromNow();

                                                if (fecha.isSame(new Date(), "day")) {
                                                    label = "Hoy";
                                                }

                                                if (fecha.isSame(moment().subtract(1, "day"), "day")) {
                                                    label = "Ayer";
                                                }

                                                if (fecha.isSame(moment().add(1, "day"), "day")) {
                                                    label = "Mañana";
                                                }

                                                return `${fecha.format("DD/MM/YYYY")} (${label})`;
                                            },
                                        },
                                        {
                                            Header: "Estado",
                                            id: "Estado",
                                            accessor: (d) => d.Estado,
                                            headerClassName: "",
                                            width: 150,
                                            filterAll: true,
                                            Cell: (row) => (
                                                <span className={`badge ${row.original.Estado === 'COMPLETADO' ? 'badge-success' : 'badge-danger'}`}>
                                                    {row.original.Estado}
                                                </span>
                                            ),
                                        },
                                        {
                                            Header: "Observación",
                                            id: "Observacion",
                                            headerClassName: "",
                                            accessor: (d) => d.Observacion,
                                            minWidth: 200,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Observacion"] }),
                                        }
                                    ]
                                }
                            ]}
                            defaultPageSize={5}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            loadingText="Cargando..."
                            noDataText="No se encontraron registros"
                            pageText="Página"
                            ofText="de"
                            rowsText="filas"
                            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                        />
                    </div>

                    {/* Modal para Gestionar Pedido */}
                    {/* {!!currentPedidoId && (
                        <GestionarPedido 
                            onChange={getPedidos} 
                            pedidoId={currentPedidoId} 
                            onClose={() => {
                                getPedidos();
                                setCurrentPedidoId(undefined);
                            }}
                        />
                    )} */}
                </div>
            </div>

            <Modal
                isOpen={showRegistrarModal}
                onClose={handleCloseRegistrarModal}
                title="Registrar Pedido de Producción"
            >
                <RegistrarPP
                    currentSucursalId={currentSucursalId}
                    canRegistrar={true}
                    onPedidoRegistered={handlePedidoRegistered}
                    onCancel={handleCloseRegistrarModal}
                    onClose={handleCloseRegistrarModal}
                />
            </Modal>
        </>
    );
}